import { render, staticRenderFns } from "./PageTerms.vue?vue&type=template&id=b3828a10&scoped=true"
import script from "./PageTerms.vue?vue&type=script&lang=js"
export * from "./PageTerms.vue?vue&type=script&lang=js"
import style0 from "./PageTerms.vue?vue&type=style&index=0&id=b3828a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3828a10",
  null
  
)

export default component.exports